import { render, staticRenderFns } from "./Atributos.vue?vue&type=template&id=188e3254&scoped=true"
import script from "./Atributos.vue?vue&type=script&lang=js"
export * from "./Atributos.vue?vue&type=script&lang=js"
import style0 from "./Atributos.vue?vue&type=style&index=0&id=188e3254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e3254",
  null
  
)

export default component.exports